module.exports = __webpack_public_path__ + "img/value-blocks-slider-infiniti.7c0534a0.png";